/**
 * QuantitySelector - Quantity controls with +/- buttons
 */
import { memo } from 'react';
import { Plus, Minus } from 'lucide-react';

const QuantitySelector = memo(function QuantitySelector({ 
  quantity, 
  onIncrease, 
  onDecrease 
}) {
  return (
    <div className="flex items-center gap-3">
      <button
        onClick={onDecrease}
        className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-muted/80 transition-colors"
        data-testid="decrease-quantity"
      >
        <Minus className="w-4 h-4" />
      </button>
      <span className="w-8 text-center font-medium text-lg">{quantity}</span>
      <button
        onClick={onIncrease}
        className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-muted/80 transition-colors"
        data-testid="increase-quantity"
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
});

export default QuantitySelector;
